/** Tenant legal entity from storefront config (pilot white-label). */

export function resolveTenantLegal(brand) {
  const tenant = brand?.tenant || {};
  if (!tenant.id) {
    return null;
  }
  const contacts = brand?.contacts || {};
  return {
    displayName: tenant.displayName || brand.name,
    legalName: tenant.legalName || tenant.legal_name || brand.name,
    edrpou: tenant.edrpou || "",
    legalAddress: tenant.legalAddress || tenant.legal_address || "",
    email: contacts.email || brand.supportEmail || "",
    phone: contacts.primaryPhone || contacts.phones?.[0]?.display || "",
  };
}
